import React from "react";

export default function SplashScreen() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0c0c0f",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
      }}
    >
      <img
         src={`${process.env.PUBLIC_URL}/logo.jpg`}
        alt="Logo"
        style={{
          width: "120px",
          height: "120px",
          objectFit: "contain",
        }}
      />

      <div className="loader" />

      <p
        style={{
          color: "#a1a1aa",
          fontSize: "14px",
          margin: 0,
        }}
      >
        Preparing your workspace...
      </p>
    </div>
  );
}